"use client";

import dynamic from "next/dynamic";

import type { DrawerProps } from "./drawer.component";

export const Drawer = dynamic<DrawerProps>(
  () => import("./drawer.component").then((mod) => mod.DrawerWrapper),
  {
    ssr: false,
  },
);
